import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { ServiceResponseData } from "../ServiceResponseData";
import { DeleteClientUserReqData } from "./DeleteClientUserReqData";

const ENDPOINT = "/usermanagement/users";

export class DeleteClientUserCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "delete";
    data: DeleteClientUserReqData;

    constructor(data: DeleteClientUserReqData) {
        super();
        this.data = data;
    }

    public async execute(): Promise<ServiceResponseData> {
        var res = await this.executeCommand(this.data);
        return new ServiceResponseData(res);
    }
}
